export const MAX_DEPTH = 3

export const sortByPosition = categories =>
    [...categories].sort((a, b) => a.position - b.position || a.name.localeCompare(b.name))

const parentId = category => (category.parent ? category.parent['@id'] || category.parent : null)

const build = (categories, id, ancestors) =>
    sortByPosition(categories.filter(category => parentId(category) === id)).map(category => {
        const path = [...ancestors, category.name]

        return {
            ...category,
            depth: path.length,
            path,
            children: build(categories, category['@id'], path),
        }
    })

export const asTree = categories => build(categories, null, [])

export const flatten = tree => tree.flatMap(node => [node, ...flatten(node.children)])

export const height = node => 1 + Math.max(0, ...(node ? node.children.map(height) : []))

const isWithin = (node, id) => node['@id'] === id || node.children.some(child => isWithin(child, id))

export const parentOptions = (tree, category) => {
    const self = category && category['@id'] ? flatten(tree).find(node => node['@id'] === category['@id']) : null
    const ownHeight = self ? height(self) : 1

    return flatten(tree).filter(
        node => node.depth + ownHeight <= MAX_DEPTH && !(self && isWithin(self, node['@id']))
    )
}

export const needsReview = node =>
    node.needsReview || node.genericArticlesNeedingReviewCount > 0 || node.children.some(needsReview)
